import type { RoleSummary } from '../components/admin/LeafConfigCard';

/** Stable key for org-chart edges and grid identity (matches AgentHierarchyView). */
export function getRoleKey(role: RoleSummary): string {
  if (role.code) return `${role.streamId}/${role.code}`;
  return `${role.streamId}/${role.product}/${role.teamType}/${role.tenantCode}`;
}

/** Resolve parentRef to a key present in `rolesByKey` (same-stream role-code shorthand). */
export function resolveParentKey(
  parentRef: string | undefined,
  childStreamId: string,
  rolesByKey: Map<string, RoleSummary>,
): string | undefined {
  const raw = parentRef?.trim();
  if (!raw) return undefined;
  if (rolesByKey.has(raw)) return raw;
  if (!raw.includes('/')) {
    const scoped = `${childStreamId}/${raw}`;
    if (rolesByKey.has(scoped)) return scoped;
  }
  return raw;
}

/** Role keys that have at least one other role pointing at them as parent (non-leaf in hierarchy). */
export function roleKeysWithChildren(roles: RoleSummary[]): Set<string> {
  const map = new Map<string, RoleSummary>();
  for (const r of roles) map.set(getRoleKey(r), r);
  const withKids = new Set<string>();
  for (const r of roles) {
    const pk = resolveParentKey(r.parentRef, r.streamId, map);
    if (pk && map.has(pk)) withKids.add(pk);
  }
  return withKids;
}
